var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ikon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.432,
    height: 18.804,
    viewBox: "0 0 13.432 18.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M15.4,5.358V2.087a2,2,0,0,1,.868.5l2.571,2.571a2,2,0,0,1,.5.868H16.074A.672.672,0,0,1,15.4,5.358Zm4.03,2.015V18.79A2.017,2.017,0,0,1,17.417,20.8h-9.4A2.017,2.017,0,0,1,6,18.79V4.015A2.017,2.017,0,0,1,8.015,2h6.044V5.358a2.017,2.017,0,0,0,2.015,2.015ZM9.358,14.76a.672.672,0,1,0-.672.672A.672.672,0,0,0,9.358,14.76Zm0-2.686a.672.672,0,1,0-.672.672A.672.672,0,0,0,9.358,12.074Zm0-2.686a.672.672,0,1,0-.672.672A.672.672,0,0,0,9.358,9.387Zm8.059,5.373a.671.671,0,0,0-.672-.672H10.7a.672.672,0,1,0,0,1.343h6.044a.671.671,0,0,0,.672-.672Zm0-2.686a.671.671,0,0,0-.672-.672H10.7a.672.672,0,1,0,0,1.343h6.044a.671.671,0,0,0,.672-.672Zm0-2.686a.671.671,0,0,0-.672-.672H10.7a.672.672,0,1,0,0,1.343h6.044a.671.671,0,0,0,.672-.672Z",
    transform: "translate(-6 -2)",
    fill: "#00a789"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModalIcon);
export default __webpack_public_path__ + "static/media/viewModalIcon.9b1d24e6c041e6de1e679057a93d3d90.svg";
export { ForwardRef as ReactComponent };